import http from '../utils/request.js'

/**
 * 收银系统API服务
 * 基于ERP收银系统API文档实现
 */

export const cashierApi = {
  /**
   * 收银员登录
   * @param {Object} data - 登录数据
   * @param {string} data.username - 收银员用户名
   * @param {string} data.password - 登录密码
   * @returns {Promise<Object>} 登录结果
   */
  login(data) {
    return http.post('/cashier/login', data)
  },

  /**
   * 获取收银员个人信息
   * @returns {Promise<Object>} 收银员信息和店铺信息
   */
  getProfile() {
    return http.get('/cashier/profile')
  },

  /**
   * 获取店铺商品分类
   * @param {number} shop_id - 店铺ID (可选)
   * @returns {Promise<Array>} 商品分类列表
   */
  getShopCategories(shop_id) {
    const params = shop_id ? { shop_id } : {}
    return http.get('/cashier/shop/categories', params)
  },

  /**
   * 获取店铺商品列表
   * @param {Object} params - 查询参数
   * @param {number} params.shop_id - 店铺ID (可选)
   * @param {string} params.keyword - 商品关键词搜索 (可选)
   * @param {number} params.category_id - 分类ID (可选)
   * @param {number} params.page - 页码 (默认1)
   * @param {number} params.page_size - 每页数量 (默认10)
   * @returns {Promise<Object>} 商品列表数据
   */
  getShopProducts(params = {}) {
    return http.get('/cashier/shop/products', params)
  },

  /**
   * 创建订单
   * @param {Object} data - 订单数据
   * @param {number} data.shop_id - 店铺ID
   * @param {string} data.customer_name - 客户姓名 (可选)
   * @param {string} data.customer_phone - 客户电话 (可选)
   * @param {Array} data.items - 订单项目列表
   * @param {number} data.total_amount - 总金额
   * @param {number} data.discount_amount - 折扣金额
   * @param {number} data.final_amount - 最终金额
   * @param {string} data.payment_method - 支付方式 (cash/card/mobile)
   * @param {string} data.remark - 备注 (可选)
   * @returns {Promise<Object>} 订单创建结果
   */
  createOrder(data) {
    return http.post('/cashier/order/create', data)
  },

  /**
   * 获取库存情况
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码 (默认1)
   * @param {number} params.pageSize - 每页数量 (默认20)
   * @param {string} params.keyword - 商品关键词搜索 (可选，支持商品名称和编码)
   * @param {number} params.categoryId - 分类ID筛选 (可选)
   * @param {string} params.stockType - 库存类型筛选 (可选: low/out/normal)
   * @returns {Promise<Object>} 库存情况数据
   */
  getInventoryStock(params = {}) {
    return http.get('/cashier/inventory/stock', params)
  }
}

export default cashierApi